import { LoadingState } from '@/entities/LoadingState';
import { MutationTree, ActionTree, GetterTree, Module, ActionContext } from 'vuex';
import { RootState } from '../rootState';
import removeNamespace from '../removeNamespace';
import { OrdersService } from '@/services/orders-service';
import { OrderInfo } from '@/entities/OrderInfo';

const ordersService = new OrdersService();

// name must match import name in rootState
const namespace = 'ordersForUser';

export const OrdersForUserModuleTypes = {
    getters: {
        orderResults: `${namespace}/orderResults`,
        orderResultsLoadingState: `${namespace}/orderResultsLoadingState`,
    },
    mutations: {
        loadOrderResults: `${namespace}/loadOrderResults`,
        loadOrderResultsSuccess: `${namespace}/loadOrderResultsSuccess`,
        loadOrderResultsFail: `${namespace}/loadOrderResultsFail`,
        setFilter: `${namespace}/setFilter`,
    },
    actions: {
        loadOrders: `${namespace}/loadOrders`,
        setFilter: `${namespace}/setFilter`,
    },
};

const types = removeNamespace(namespace, OrdersForUserModuleTypes);

export interface OrdersForUserState {
    orderResults: OrderInfo[];
    orderResultsLoadingState: LoadingState;
    orderResultsFiltered: OrderInfo[];
}

const state: OrdersForUserState = {
    orderResults: [],
    orderResultsLoadingState: LoadingState.Indeterminate,
    orderResultsFiltered: [],
};

const mutations: MutationTree<OrdersForUserState> = {
    [types.mutations.loadOrderResults](currentState: OrdersForUserState): void {
        currentState.orderResultsLoadingState = LoadingState.Loading;
    },
    [types.mutations.loadOrderResultsSuccess](currentState: OrdersForUserState, payload: OrderInfo[]): void {
        currentState.orderResults = payload;
        currentState.orderResultsFiltered = payload;
        currentState.orderResultsLoadingState = LoadingState.Loaded;
    },
    [types.mutations.loadOrderResultsFail](currentState: OrdersForUserState): void {
        currentState.orderResults = [];
        currentState.orderResultsFiltered = [];
        currentState.orderResultsLoadingState = LoadingState.Failed;
    },
    [types.mutations.setFilter](currentState: OrdersForUserState, payload: OrderInfo[]): void {
        currentState.orderResultsFiltered = payload;
    },
};

const actions: ActionTree<OrdersForUserState, RootState> = {
    [types.actions.loadOrders](context: ActionContext<OrdersForUserState, RootState>, payload: string): void {
            context.commit(types.mutations.loadOrderResults);
            ordersService.getAllOrdersForUser()
                .then((response) => {
                    context.commit(types.mutations.loadOrderResultsSuccess, response);
                })
                .catch((e) => {
                    context.commit(types.mutations.loadOrderResultsFail);
                });
    },
    [types.actions.setFilter](context: ActionContext<OrdersForUserState, RootState>, payload: string ): void {
        const lowerFilterTerm = payload.toLowerCase();
        if (payload.length > 0) {
            const result = context.state.orderResults.filter((item) =>
                item.number.toLowerCase().includes(lowerFilterTerm) ||
                item.name.toLowerCase().includes(lowerFilterTerm) ||
                item.lines.find((subItem) => subItem.dmsPartNumber.toLowerCase().includes(lowerFilterTerm)) !== undefined);
            context.commit(types.mutations.setFilter, result);
        } else {
            context.commit(types.mutations.setFilter, context.state.orderResults);
        }
    },
};

const getters: GetterTree<OrdersForUserState, RootState> = {
    [types.getters.orderResults]: (currentState) => {
        return currentState.orderResultsFiltered;
    },
    [types.getters.orderResultsLoadingState]: (currentState) => {
        return currentState.orderResultsLoadingState;
    },
};

const module: Module<OrdersForUserState, RootState> = {
    state,
    mutations,
    actions,
    getters,
    namespaced: true,
};

export default module;
